import { render } from "./AppDialog.vue?vue&type=template&id=2d1007b2"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"
script.render = render

export default script